module.exports = __webpack_public_path__ + "img/savology-screen-5.64273e99.png";